// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetEmail":"zc_a bhs_px bhs_a bhs_w bhs_cw bhs_sb","PasswordResetEmail__title":"zc_b bhs_uj bhs_qk bhs_tu","PasswordResetEmail__subtitle":"zc_c bhs_tu"};